<template>
  <v-container fluid>
    <v-card outlined>
      <v-card-title> Pending operations</v-card-title>
      <v-snackbar v-if="snackbar"
                  v-model="snackbar"
                  :timeout="timeout"
                  color="#F44336"
                  bottom="bottom"> {{ text }}
        <v-btn color="white" text> close</v-btn>
      </v-snackbar>
      <v-tabs v-model="tab" background-color="#373737" centered dark dense icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1"> Pending
          <v-icon>mdi-basket</v-icon>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-col sm="12" class="text-center">
          <v-progress-linear
              :active="loading"
              :indeterminate="loading"
              absolute
              top
              color="orange accent-4"
          ></v-progress-linear>
        </v-col>
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <v-form ref="form">
                <v-row>
                  <v-col cols="6" md="6">
                    <v-text-field :id="dynamicID()" v-model="form.cardnumber"
                                  placeholder="Numéro de carte"></v-text-field>
                    <v-btn class="mr-2 mt-2" color="brown darken-4" dark @click="GetPostOne">
                      <v-icon>mdi-send</v-icon>
                      Postone
                    </v-btn>
                    <v-btn color="brown darken-4" class="mr-2 mt-2" dark @click="delPending">
                      <v-icon>mdi-delete</v-icon>
                      Delete
                    </v-btn>
                    <v-btn color="brown darken-4" class="mr-2 mt-2" dark @click="formatPending">
                      <v-icon>mdi-plus</v-icon>
                      Format
                    </v-btn>
                    <v-btn color="brown darken-4" class="mr-2 mt-2" dark @click="resetPending">
                      <v-icon>mdi-timer-off</v-icon>
                      Reset
                    </v-btn>
                    <v-btn color="brown darken-4" class="mr-2 mt-2" dark @click="lockPending">
                      <v-icon>mdi-lock</v-icon>
                      lock
                    </v-btn>
                    <v-btn color="brown darken-4" class="mt-2 mr-2" dark @click="unlockPending">
                      <v-icon>mdi-lock-open</v-icon>
                      unlock
                    </v-btn>
                    <v-btn color="brown darken-4" class="mt-2 mr-2" dark @click="histoPending">
                      <v-icon>mdi-calendar</v-icon>
                      Histo
                    </v-btn>
                    <v-btn color="brown darken-4" class="mt-2 mr-2" dark @click="allPending">
                      <v-icon>mdi-database</v-icon>
                      Get all
                    </v-btn>

                  </v-col>
                  <v-col cols="6" md="6">
                    <vue-json-pretty :data="result"></vue-json-pretty>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import VueJsonPretty from "vue-json-pretty";
import apiClient from "../../config/api.js";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
      snackbar: false,
      text: "",
      timeout: 2000,
      loading: false,
      form: {
        cardnumber: ""
      },
      result: {
        response: ""
      },
      tab: null
    };
  },
  components: {
    VueJsonPretty
  },
  methods: {
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    rndStr(len) {
      let text = "";
      let chars = "abcdefghijklmnopqrstuvwxyz";
      for (let i = 0; i < len; i++) {
        text += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return text;
    },
    GetPostOne() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/histo/` +
          this.form.cardnumber +
          "/" +
          this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    delPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/delete` +
          this.form.cardnumber +
          "/" +
          this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    formatPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/format/` +
          this.form.cardnumber +
          "/" +
          this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    resetPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/reset/` +
          this.form.cardnumber +
          "/" +
          this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    lockPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/lock/` + this.form.cardnumber + "/" + this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    unlockPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/unlock/` +
          this.form.cardnumber +
          "/" +
          this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    histoPending() {
      if (this.form.cardnumber === "") {
        this.snackbar = true;
        this.text = "* Le numéro de carte est obligatoire";
        return;
      }
      this.loading = true;
      apiClient.post(
          `${this.$store.getters.user.baseUrl}/command/postpone/histo/` + this.form.cardnumber + "/" + this.rndStr(7)
      )
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    },
    allPending() {
      this.loading = true;
      apiClient.get(`${this.$store.getters.user.baseUrl}/command/postpone/all/` + this.rndStr(7))
          .then(res => {
            setTimeout(() => (this.loading = false), 3000);
            this.result = res.data;
          })
          .catch(() => {
            this.loading = false;
          });
    }
  }
};
</script>